import type { TestCaseTItem } from "../../core";
import { tCasesPredicateFind } from "../predicateFind";

export type TCasesFindByIdArg = {
  rootItem: TestCaseTItem;
  id: TestCaseTItem["id"];
};
export type TCasesFindByIdRtrn = TestCaseTItem | null;

export const tCasesFindById = (arg: TCasesFindByIdArg): TCasesFindByIdRtrn =>
  tCasesPredicateFind({ rootTreeItem: arg.rootItem, predicate: (it) => it.id === arg.id });
